export const DRAWER_WIDTH = 225;
export const DRAWER_WIDTH_COLLAPSED = 80;
